import React from "react";

export const Spinner: React.FC = () => {
  return (
    <div className="row vertical-center">
      <div className="col-12 text-center my-auto">
        <img src="/spinner.svg" className="spinner" alt="spinner" />
      </div>
    </div>
  );
};

interface ISpinnerPage {
  isShowLoading: boolean;
}

export const SpinnerPage: React.FC<ISpinnerPage> = (props: ISpinnerPage) => {
  const { isShowLoading } = props;
  if (isShowLoading) {
    return (
      <div className="container wrapper-spinner col-12 h-100">
        <div className="row vertical-center justify-content-center">
          <div className="spinner-border text-danger" role="status"></div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};
